module.exports = __webpack_public_path__ + "img/SSS-J-16.45b4e1e8.svg";